import styled from "styled-components";
import { hexToRGB } from "@shared/utils/misc";

export const ListItemWrapper = styled.div<{ $invalid: boolean }>`
  color: ${(p) => p.theme.colors.textColor};
  cursor: pointer;
  ${(props) =>
    props.$invalid &&
    `
    color: ${hexToRGB(props.theme.colors.secondaryText, 0.5)};
  `}
`;

export const ListItemNameAndIconWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const ListInnerItemWrapper = styled.div`
  padding: 14px 0;
  margin: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: ${(p) => p.theme.borders.lightest};
`;
